import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        token: null,
        currentUser: null,
        basket: {
            basketElements:[],
            productExtra:{}
        },
        watched: {
            list:[]
        },
        loggedIn: null,
        orderBasketToken: null,
        searchQuery:null,
        backArrow: false,
    },
    getters: {
        getCurrentToken: function (state) {
            var token = state.token;
            if (token == null){
                token = localStorage.currentToken;
                if (token != undefined && token != null){
                    state.token = token;
                    return token;
                }else{
                    return null;
                }
            }
            return token;
        },
        getCurrentUser: function (state) {
            var user = state.currentUser;
            if (user == null){
                user = localStorage.currentUser;
                if (user){
                    state.currentUser = user;
                    return user;
                }else{
                    return null;
                }
            }
            return user;
        },
        getBasket:function (state) {
            return state.basket;
        },
        getWatched:function (state) {
            return state.watched;
        },
        getOrderBasketToken:function (state) {
            return state.orderBasketToken;
        },
        getSearchQuery:function (state) {
            return state.searchQuery;
        },
        isLoggedIn:function (state) {
            var loggedIn = state.loggedIn;
            if (loggedIn == null){
                loggedIn = localStorage.loggedIn;
                if (loggedIn != undefined && loggedIn != null){
                    loggedIn = (loggedIn == 'true');
                    state.loggedIn = loggedIn;
                    return loggedIn;
                }else{
                    return false;
                }
            }
            return loggedIn;
        }
    },
    mutations: {
        setCurrentToken:function (state,s) {
            localStorage.currentToken = s;
            state.token = s;
        },
        setCurrentUser:function (state,s) {
            localStorage.currentUser = s;
            state.currentUser = s;
        },
        setBasket:function (state,basket) {
            state.basket = basket;
        },
        setWatched:function (state,watched) {
            state.watched = watched;
        },
        setLoggedIn:function (state,l) {
            localStorage.loggedIn = l;
            state.loggedIn = l;
        },
        setOrderBasketToken:function (state,t) {
            state.orderBasketToken = t;
        },
        setSearchQuery:function (state,q) {
            state.searchQuery = q
        },
    }
});



// WEBPACK FOOTER //
// ./src/app/main/store.js